import React from 'react';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

const ParagraphThemesOverview: React.FC = () => (
  <div className="Paragraph ParagraphThemesOverview">
    <Container>
      <View
        id="themes_filtered"
        display="parent_theme"
      />
    </Container>
  </div>
);

export default ParagraphThemesOverview;
